// import Immutable from 'immutable'
import {
    CHANGE_LOGIN,
    CHANGE_EXAMINETYPE,
    CHANGE_LOGINVISIBLE,
    CHANGE_USERINFO,
    CHANGE_LANG,
} from '@openplatform/store/actionTypes/homepage';
import { getUserInfo } from '@/utils/index';

const initialState = {
    count: 1,
    // 登录状态
    isLogin: !!getUserInfo().userid,
    // 登录弹窗
    loginVisible: false,
    // 0:未入驻 1:入驻审核中 2:入驻成功 3:审核失败 4: 停止认证（和未入驻一样的处理）
    examineType: Number(localStorage.getItem('examineType')) || 0,
    // 用户信息
    userInfo: {
        userid: '',
        apptoken: getUserInfo().apptoken,
        nickName: '',
        thirdId: '',
        country: localStorage.getItem('country') || '',
    },
    curLang: localStorage.getItem('curLang') || 'zh',
};

const reducer = (state = initialState, action: any) => {
    const { type, data } = action;
    switch (type) {
        // 登录状态
        case CHANGE_LOGIN: {
            const newState = JSON.parse(JSON.stringify(state));
            newState.isLogin = data;
            return newState;
        }
        // 入驻状态
        case CHANGE_EXAMINETYPE: {
            const newState = JSON.parse(JSON.stringify(state));
            newState.examineType = data;
            return newState;
        }
        // 登录弹窗显隐
        case CHANGE_LOGINVISIBLE: {
            const newState = JSON.parse(JSON.stringify(state));
            newState.loginVisible = data;
            return newState;
        }
        case CHANGE_USERINFO: {
            const newState = JSON.parse(JSON.stringify(state));
            newState.userInfo = { ...state.userInfo, ...data };
            return newState;
        }
        // 修改语言
        case CHANGE_LANG: {
            const newState = JSON.parse(JSON.stringify(state));
            newState.curLang = data;
            localStorage.setItem('curLang', data);
            return newState;
        }
        default: {
            return state;
        }
    }
};
export default reducer;
